import React from "react";
import { noDataImg } from "../../assets";
import { twMerge } from "tailwind-merge";
import { MdSearchOff } from "react-icons/md";
import { IoDocumentTextOutline } from "react-icons/io5";

const NoData = ({ text, className, textStles }) => {
  return (
    <div
      className={twMerge(
        "flex flex-col justify-center items-center py-4 px-4",
        className
      )}
    >
      <div className="relative mb-6">
        <div className="w-24 h-24 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center">
          <IoDocumentTextOutline className="text-gray-400 text-5xl" />
        </div>
        <div className="absolute -bottom-1 -right-1 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
          <MdSearchOff className="text-primary text-xl" />
        </div>
      </div>
      
      <h3
        className={twMerge(
          "text-center text-lg font-bold text-gray-900 mb-2",
          textStles
        )}
      >
        {text || "No Data Found"}
      </h3>
      
      <p className="text-center text-sm text-gray-500 max-w-sm">
        We couldn't find any results matching your criteria. Try adjusting your filters or search terms.
      </p>
    </div>
  );
};

export default NoData;
